(() => {
  const start = (scope = document) => {
    const heroes = scope.matches?.('[data-vs-hero]') ? [scope] : scope.querySelectorAll('[data-vs-hero]');
    heroes.forEach((hero) => {
      if (hero.dataset.vsReady) return;
      hero.dataset.vsReady = 'true';
      const form = hero.querySelector('.vs-form');
      const floating = hero.querySelector('[data-vs-floating]');
      const dialog = hero.querySelector('[data-vs-dialog]');
      const photo = hero.querySelector('.vs-hero-image');
      const enlarged = dialog.querySelector('img');
      const zoom = hero.querySelector('[data-vs-zoom]');
      const photoAttributes = ['src', 'srcset', 'sizes', 'width', 'height', 'alt'];
      const mainPhoto = Object.fromEntries(photoAttributes.map((name) => [name, photo.getAttribute(name)]));
      const views = [...hero.querySelectorAll('[data-vs-view]')];
      views.forEach((choice) => {
        choice.addEventListener('keydown', (event) => {
          if (event.key === ' ') { event.preventDefault(); choice.click(); }
        });
        choice.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const values = choice.dataset.vsView === 'main' ? mainPhoto : {
            src: choice.dataset.src, srcset: choice.dataset.srcset || null, sizes: choice.dataset.srcset ? "(min-width: 750px) 46vw, 96vw" : null, width: choice.dataset.width || '1536', height: choice.dataset.height || '1024', alt: choice.dataset.alt
          };
          [photo, enlarged].forEach((image) => photoAttributes.forEach((name) => {
            if (values[name] === null) image.removeAttribute(name);
            else image.setAttribute(name, values[name]);
          }));
          zoom.href = values.src;
          hero.querySelector('[data-vs-caption]').textContent = choice.dataset.caption || '';
          hero.querySelectorAll('[data-vs-view]').forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
        });
      });
      const stepView = (step) => {
        if (!views.length) return;
        const current = Math.max(0, views.findIndex(view => view.getAttribute('aria-pressed') === 'true'));
        views[(current + step + views.length) % views.length].click();
      };
      hero.querySelectorAll('[data-vs-step]').forEach(button => {
        button.hidden = views.length < 2;
        button.addEventListener('click', () => stepView(Number(button.dataset.vsStep)));
      });
      hero.querySelector('.vs-hero-media').addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        stepView(event.key === 'ArrowLeft' ? -1 : 1);
      });
      hero.querySelector('[data-vs-zoom]').addEventListener('click', (event) => {
        if (!dialog.showModal) return;
        event.preventDefault();
        dialog.showModal();
      });
      hero.querySelector('[data-vs-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      const update = (input, announce = false) => {
        hero.querySelectorAll('[data-vs-price], [data-vs-floating-price]').forEach((el) => { el.textContent = input.dataset.price; });
        const button = hero.querySelector('[data-vs-add]');
        const available = input.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        const payment = hero.querySelector('[data-vs-payment]');
        if (payment) payment.hidden = !available;
        if (announce) {
          const url = new URL(location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState({}, '', url);
          hero.querySelector('[data-vs-status]').textContent = `${input.dataset.title} — ${input.dataset.price}`;
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-vs-variant]')) update(event.target, true);
      });
      const chosen = form.querySelector('[data-vs-variant]:checked');
      if (chosen) update(chosen);
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        const observer = new IntersectionObserver(([entry]) => {
          floating.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        observer.observe(form);
        hero._vsObserver = observer;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  if (!window.cfVitalStepEditor) {
    window.cfVitalStepEditor = true;
    document.addEventListener('shopify:section:load', (event) => start(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-vs-hero]').forEach((hero) => hero._vsObserver?.disconnect());
    });
  }
})();
